import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Modal } from "semantic-ui-react";
import TourBuilder from "~/applications/tourbuilder/components/TourBuilder";
import Geocoder from "~/utils/GoogleMaps/Geocoder";
import CountryStore from "~/stores/CountryStore";
import ModalTourBuilderStore from "../stores/ModalTourBuilderStore";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import ConstantStore from "~/stores/ConstantStore";

@observer
class ModalTourBuilderWidget extends Component {
  countryStore = null;

  geocoder = null;

  constructor(props) {
    super(props);

    this.countryStore = new CountryStore();
    this.geocoder = new Geocoder();
    this.constantStore = new ConstantStore();

    this.state = {
      activeComponent: "tour",
    };
  }

  componentDidMount() {
    const { showError, modalTourBuilderStore } = this.props;

    this.countryStore.load().catch(error => showError(error.message));
    this.constantStore.load([ConstantStore.CONSTANTS.TIMEZONES]);
    modalTourBuilderStore.load().catch(error => showError(error.message));
  }

  onActiveComponentChange(activeComponent) {
    this.setState({ activeComponent });
  }

  close() {
    const { modalTourBuilderStore } = this.props;
    const { createTourStore } = modalTourBuilderStore;
    const { isSaving } = createTourStore;

    if (isSaving) {
      return;
    }

    modalTourBuilderStore.close();
  }

  render() {
    const { activeComponent } = this.state;
    const { modalTourBuilderStore, onTourCreated, onTourUpdated, createTourCustomText } = this.props;
    const { createTourStore, createCustomerStore, showCustomerSection } = modalTourBuilderStore;

    return (
      <Modal
        size="small"
        className="tour-builder"
        open={modalTourBuilderStore.isOpen}
        onClose={() => this.close()}
        closeIcon
      >
        <Modal.Header>
          {activeComponent === "tour" ? createTourCustomText.header || "Create a Tour" : "Create a Customer"}
        </Modal.Header>
        <Modal.Content>
          <TourBuilder
            geocoder={this.geocoder}
            countryStore={this.countryStore}
            createTourStore={createTourStore}
            createCustomerStore={createCustomerStore}
            createTourCustomText={createTourCustomText}
            onActiveComponentChange={newActiveComponent => this.onActiveComponentChange(newActiveComponent)}
            showCustomerSection={showCustomerSection}
            onTourCreated={onTourCreated}
            onTourUpdated={onTourUpdated}
            constantStore={this.constantStore}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

ModalTourBuilderWidget.propTypes = {
  createTourCustomText: PropTypes.shape({
    header: PropTypes.string,
  }),
  modalTourBuilderStore: PropTypes.instanceOf(ModalTourBuilderStore),
  onTourCreated: PropTypes.func,
  onTourUpdated: PropTypes.func,
};

ModalTourBuilderWidget.defaultProps = {
  createTourCustomText: {},
};

TourBuilder.defaultProps = {
  onTourCreated: tourId => {
    window.location.href = `/panel/tour/edit/${tourId}?tabView=tabImages`;
  },
};

export default ErrorWrapper(ModalTourBuilderWidget);
